<style lang="less" scoped>
@import '../../../style/common/variable';
.zlkKeywords{position: relative;width: 100%;margin-top: 5px;font-family: AlibabaPuHuiTi-Medium;}
ul {list-style: none;width: 780px;height: 940px;border: solid rgb(206, 205, 205);border-width: 1px;margin-top: 20px;text-align: left;overflow: hidden;}
li {float: left;width: 360px;margin-top: 10px;font-size: 14px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;cursor: pointer;}
span::before {content: "●";margin-right: 5px;}
li:first-child{color: black;}
li:nth-child(1), li:nth-child(2){margin-top: -20px;}
li:nth-child(2n+1) {margin-left: -10px;margin-right: 40px;}
li:nth-child(2n) {margin-right: 0px;}
li:hover {color: #13569e;}
.block{margin: 0px auto;}
@media screen and (max-width: @max-screen){
  .third{display: none;}
  .zlkKeywords{width: 100vw;
    ul{display:flex; flex-direction:column;width: 87vw; height: auto;
      li{width: 85vw; margin: .1rem 0 0;}
    }
  }
  .pagination{display: flex;flex-wrap: wrap;justify-content: center;}
}
</style>

<template>
  <div class="zlkKeywords">
    <ul v-if="keyWordsdata.length > 0">
      <li v-for="(item, index) in keyWordsdata" :key="index" v-show="item.title" @click="goDetails(item)">
        <span>{{ item.title }}</span>
      </li>
    </ul>
    <div class="block" v-if="keyWordsdata.length > 0">
      <el-pagination
        class="pagination"
        @size-change="handleSizeChange(this.form.count)"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="countSum">
      </el-pagination>
    </div>
  </div>
</template>

<script>
/**
 * 何宽 资料库关键词内容页面
 */
export default {
  name: '',
  data()
  {
    return {
      keyWordsdata: [], // 根据搜索条件获取到的数据
      count: 64,
      pageSize: 64,
      currentPage: 1,
      countSum: null,
      val1: '',
      val2: '',
      val3: '',
      val4: ''
    }
  },
  watch:
  {
    $route: {
      handler(nval, oval)
      {
        this.val1 = nval.query.keyword //val1 关键词
        this.val2 = +nval.query.catid  //val2 分类id
        this.val3 = nval.query.sort    //val3 推荐方式
        this.val4 = +nval.query.ssgj   //val4 国家
        this.getList()
      },
      immediate: true
    }
  },
  methods: {
    // 获取关键词搜索数据
    getList()
    {
      let count = this.count
      let currentPage = this.currentPage
      //构造请求语句
      let exp = ''
      let sort = ''
      //筛选条件
      if (this.val1 !== '')
        exp += `${'title'} like '%${this.val1}%' and `
      if (this.val2 !== 0)
        exp += `catid = ${this.val2} and `
      if (this.val4 !== 0)
        exp += `ssgj = ${this.val4} and `
      if (this.val3 !== '')
        sort = `${this.val3}`
      exp = exp ? `${exp}examine = 0` : 'id>0 and examine = 0'
      sort = sort ? `${sort}` : 'addtime DESC'
      let paras = {cmd: 'query', _major: 11, _minor: 24, _exp: exp, orderby: sort, init: 0, pageno: `${currentPage}`, pagesize: `${count}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.countSum = ret[0].total
        this.keyWordsdata = [{id: 0, title: ''}, {id: 1, title: ''}]
        ret[0].data.forEach(item => this.keyWordsdata.push({id: item.id, title: item.title}))
      })
    },
    // 跳转到矿业资讯详情页面，并将被点击的对象的id提交到vuex
    goDetails(item)
    {
      let url = this.$router.resolve({path: '/ZlkDetails', query: {id: item.id}})
      window.open(url.href, '_blank')
    },
    //当选择项发生变化时会触发该事件
    handleSelectionChange(val)
    {
      let temp = []
      val.forEach((item) => temp.push(item.id))
      this.multipleSelection = temp
    },
    //每页条数
    handleSizeChange(val)
    {
      this.pageSize = val
    },
    //当前页数
    handleCurrentChange(val)
    {
      this.currentPage = val
      this.search()
    },
    search()
    {
      this.getList()
      this.handleSizeChange(this.count)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/project/ZlkKeywords.vue